import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import HudCard from './components/HudCard';
import Stats from './components/Stats';
import Features from './components/Features';
import TechStack from './components/TechStack';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      {/* Background Overlay */}
      <div className="background-overlay"></div>
      
      {/* Main Container */}
      <div className="app-container">
        <Header />
        
        <main className="main">
          <Hero />
          <HudCard />
          <Stats />
          <Features />
          <TechStack />
          <Contact />
        </main>
        
        <Footer />
      </div>
    </div>
  );
}

export default App;
